export function getFeatureFlags() {
    const urlParams = new URLSearchParams(window.location.search);
    return {
        enableDigitalAccess: urlParams.has('enableDigitalAccess'),
    };
}
